import { MDText } from 'i18n-react';

import cypressIds from 'Components/cypress_ids.json';
import type { ColumnCellProps } from 'Storybook/core/Datagrid/Datagrid.types';
import { CellTextAlign } from 'Storybook/core/Datagrid/Datagrid.types';
import type { AccountSlugs, SortBy } from 'Types/account';
import type { Order } from 'Types/generic';

import LocalTexts from './BidsAndOffersVehicleList.texts';

const LocalT = new MDText(LocalTexts);
export const getBidsAndOffersListColumns = ({
	slug,
	sorts,
}: {
	slug: AccountSlugs;
	sorts: { order: Order; sortBy: SortBy };
}): Array<ColumnCellProps> => {
	return [
		{
			cypressId: cypressIds.accountDataGrid.dataGridHeaders.vehicles,
			id: 'vehicles',
			sortable: true,
			text: LocalT.translate('headers.vehicle'),
		},
		{
			cypressId: cypressIds.accountDataGrid.dataGridHeaders.status,
			id: 'status',
			text: LocalT.translate(`headers.status.${slug}`),
			textAlign: CellTextAlign.Right,
		},
		{
			cypressId: cypressIds.accountDataGrid.dataGridHeaders.maxBidOffer,
			id: 'maxBidOffer',
			sortable: true,
			text: LocalT.translate('headers.maxBidOffer'),
			textAlign: CellTextAlign.Right,
		},
		{
			cypressId: cypressIds.accountDataGrid.dataGridHeaders.dateBid,
			id: 'dateBid',
			sortable: true,
			text: LocalT.translate('headers.dateBid'),
			textAlign: CellTextAlign.Right,
		},
	].map((column) => {
		const { id } = column;

		if (id === sorts.sortBy) {
			return { ...column, sortDirection: sorts.order };
		}

		return column;
	});
};
